import { useIntl } from "react-intl"
import { useEffect, useRef, useState } from "react"
import { Combobox, CustomTable, CustomTableRef, EInputTypes, formatDate, getDate, GetItemsProps, InputDate, InputTextCustom } from "medere-ui-framework"
import { Column } from "primereact/column"
import { BudgetDTO, adaptBudgetDTO, defaultBudgetDTO } from "../../dto/budget/BudgetDTO"
import './Budget.scss'
import { EBudgetGridOptions, EBudgetGridOptionsValues } from "../../enums/EBudgetGridOptions"
import { cancelBudget, changeBudgetState, duplicateBudget, getAllBudgets, getBudgetComplete, getBudgetStates } from "../../servicesHooks/Budget/useBudgetService"
import { ComboDataDTO, defaultAllComboDataDTO } from "../../dto/ComboDataDTO"
import React from "react"
import DuplicateBudgetModal from "./DuplicateBudgetModal"
import { useEntityService } from "../../servicesHooks/Entity/useEntityService"

interface HistoricBudgetsViewProps {
    selectedAction: number;
    setSelectedAction: (action:number) => void;
    setSelectedBudget: (selectedBudget:BudgetDTO) => void;
    setOpenPrintBudgetModal: (value:boolean) => void;
    filterHospitalization?: boolean;
}

export default function HistoricBudgetsView({selectedAction,setSelectedAction,setSelectedBudget,setOpenPrintBudgetModal,filterHospitalization}:HistoricBudgetsViewProps) {

    const { getHealthEntityComboDataDTO } = useEntityService();
    const intl = useIntl();
    const queryRef = useRef<CustomTableRef>(null);
    const [filterAddressee, setFilterAddressee] = useState<string>("");
    const [filterHealthEntity, setFilterHealthEntity] = useState<ComboDataDTO>(defaultAllComboDataDTO);
    const [filterBudgetId, setFilterBudgetId] = useState<number | null>(null);
    const [filterDate, setFilterDate] = useState<Date>();
    const [filterDetail, setFilterDetail] = useState<string>("");
    const [filterState, setFilterState] = useState<ComboDataDTO>(defaultAllComboDataDTO);

    const [openDuplicateBudgetModal, setOpenDuplicateBudgetModal] = useState<boolean>(false); 
    const [currentSelectedBudget, setCurrentSelectedBudget] = useState<BudgetDTO>(defaultBudgetDTO);

    function onDuplicateBudget(budget:BudgetDTO){
        setSelectedBudget(budget);
        setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE])
    }
    
    return (
        <React.Fragment>
            <CustomTable idTable="tablebudget" getItems={getAllBudgets} 
            clearFiltersClassName="buttonControl"
            params={{
                filterAddressee:filterAddressee,
                filterHealthEntity:filterHealthEntity.id,
                filterBudgetId:filterBudgetId,
                filterDate:filterDate,
                filterDetail:filterDetail,
                filterState:filterState.id,
                filterHospitalization:filterHospitalization,
            }}
            minItemWidth
            className='historicBudgetTable crudTable editable-cells-table'
            onClearFilters={() => {
                setFilterAddressee("");
                setFilterHealthEntity(defaultAllComboDataDTO);
                setFilterBudgetId(null);
                setFilterDate(undefined);
                setFilterDetail("");
                setFilterState(defaultAllComboDataDTO);
            }}
            rowButtonClassName="" 
            buttonController 
            dropdownExtraButtons={
                [{
                    text: intl.formatMessage({ id: 'Preview' }),
                    icon: 'pi pi-eye',
                    onClick: (selectedBudget:BudgetDTO) => {
                        getBudgetComplete(selectedBudget.budget ?? -1).then((res:BudgetDTO) => {
                            setSelectedBudget(res);
                            setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.PREVIEW])
                        });
                    }
                },
            {
                text: intl.formatMessage({ id: 'Edit' }),
                icon: 'pi pi-pencil',
                showWhen: () => (selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.PREVIEW] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]),
                onClick: (selectedBudget:BudgetDTO) => {                    
                    getBudgetComplete(selectedBudget.budget ?? -1).then((res:BudgetDTO) => {
                        setSelectedBudget(res);
                        setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.EDIT])
                    });
                }
            }, ,/*{
                text: intl.formatMessage({ id: 'SendByEmail' }),
                icon: 'pi pi-send',
                onClick: (selectedBudget:BudgetDTO) => {
                    
                }
            }, */{
                text: intl.formatMessage({ id: 'Duplicate' }),
                icon: 'pi pi-clone',
                showWhen:() => (selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]),
                onClick: (selectedBudget:BudgetDTO) => {
                    setCurrentSelectedBudget(selectedBudget);
                    setOpenDuplicateBudgetModal(true);
                }
            },{
                text: "Generar orden",
                icon: 'pi pi-dollar',
                showWhen:(selectedBudget:BudgetDTO) => selectedBudget.budgetstate == 3,
                onClick: (selectedBudget:BudgetDTO) => {
                    getBudgetComplete(selectedBudget.budget?? -1).then((res:BudgetDTO) => {
                        setSelectedBudget(res);
                        setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.PREINVOICE])
                    });
                }
            }, {
                text: "Descargar PDF",
                icon: 'pi pi-download',
                onClick: (selectedBudget:BudgetDTO) => {
                    setSelectedBudget(selectedBudget);
                    setOpenPrintBudgetModal(true);
                }
            }, {
                text: intl.formatMessage({ id: 'Cancel' }),
                icon: 'pi pi-times',
                showWhen:() => (selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]),
                onClick: (selectedBudget:BudgetDTO) => {
                    setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.CANCEL])
                    cancelBudget(selectedBudget?.budget ?? -1).then((res:ComboDataDTO) => {
                        if (queryRef.current?.refreshTable)
                            queryRef.current?.refreshTable();
                    });
                    
                }
            }]} ref={queryRef}>
                <Column field="addresseedesc" header={intl.formatMessage({id:'Addressee'})} className="columnMedium" 
                body={(bud:BudgetDTO) => <div className=' text-left'>{bud.addressee}</div> } 
                filter 
                filterElement= {
                    <InputTextCustom placeholder={intl.formatMessage({ id: "Addressee" })}
                    value={filterAddressee}
                    inputType={EInputTypes.TEXT}
                    onChange={(e: any) => setFilterAddressee(e.target.value )} 
                />
                }/>
                
                <Column field="agreementdesc" header={intl.formatMessage({id:'Agreement'})} className="columnMedium"  
                body={(bud:BudgetDTO) => <div className=' text-left'>{bud.agreementdesc}</div>} 
                filter 
                filterElement= {
                    <Combobox
                    getItems={(getItemProps:GetItemsProps)=> {
                        return getHealthEntityComboDataDTO(getItemProps).then((res:any)=>{
                            return [defaultAllComboDataDTO,...res];
                        })    
                    }}
                    minPanelWidth={250}
                    optionLabel='name' 
                    placeholder={intl.formatMessage({id:'Agreement'})} 
                    value={filterHealthEntity.name}
                    setValue={(e:ComboDataDTO) => {
                        if(e)
                            setFilterHealthEntity(e); 
                    }}
                />
                }/>
                
                <Column field="budgetnumber" header={'Nº'} className="columnSmall text-center budget-col-number"
                filter 
                filterElement= {
                    <InputTextCustom placeholder={"Nº"}
                    value={filterBudgetId}
                    inputType={EInputTypes.NUMBER}
                    onChange={(e: any) => setFilterBudgetId(e.target.value )}
                    /> 
                }/>

                <Column field='date' header={intl.formatMessage({ id: "Date" })} className='columnDate text-center budget-col-date' 
                body={(bud:BudgetDTO) => formatDate(getDate(bud.date))}
                filter 
                filterElement= {
                    <InputDate value={filterDate ?? new Date()} onChange={(e) => setFilterDate(e.value)} />
                }/>

                <Column field="detail" header={intl.formatMessage({id:'Description'})}
                body={(bud:BudgetDTO) => <div className='text-left'>{bud.detail}</div>}
                filter 
                filterElement= {
                    <InputTextCustom placeholder={intl.formatMessage({ id: "Detail" })}
                    
                    value={filterDetail}
                    inputType={EInputTypes.TEXT}
                    onChange={(e: any) => setFilterDetail(e.target.value )} 
                    />
                }/>

                <Column field="budgetstatedescription" header={"Estado"} className="columnMedium"  
                body={(bud:BudgetDTO) => <div className=' text-left'>{bud.budgetstatedescription}</div>} 
                filter 
                filterElement= {
                    <Combobox
                    getItems={(getItemProps:GetItemsProps)=> {
                        return getBudgetStates(getItemProps).then((res:any)=>{
                            return [defaultAllComboDataDTO,...res];
                        })    
                    }}
                    minPanelWidth={150}
                    optionLabel='name' 
                    placeholder="Estado"
                    value={filterState.name}
                    setValue={(e:ComboDataDTO) => setFilterState(e)} 
                    />
                }/>

                <Column field="value" className="w-12p columnR" header={intl.formatMessage({ id: 'Budget' })} 
                body={(bud:BudgetDTO) => {
                        return (
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>$</span>
                                <span style={{ textAlign: 'right' }}>
                                    {bud.total?bud.total.toLocaleString('es-AR', {
                                        maximumFractionDigits: 2,
                                        style: 'decimal'
                                    }):'0'}
                                </span>
                            </div>
                        );
                    }}
                />
            </CustomTable>

            <DuplicateBudgetModal openDuplicateBudgetModal={openDuplicateBudgetModal} setOpenDuplicateBudgetModal={setOpenDuplicateBudgetModal} budgetId={currentSelectedBudget.budget ?? -1} onDuplicateBudget={onDuplicateBudget}/>
        </React.Fragment>
    )
}
